import classes from "./Register1.module.css";
import { useRef } from "react";
import axios from "axios";
import logo from "./../../assets/icons/Logo_register.png";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

function Register1(props) {
  const navigate = useNavigate();
  const nameInputRef = useRef();
  const familyInputRef = useRef();
  const phoneInputRef = useRef();
  const usernameInputRef = useRef();
  const passwordInputRef = useRef();
  const repeatPasswordInputRef = useRef();

  function postRegisterData() {
    const requestData = {
      first_name: nameInputRef.current.value,
      last_name: familyInputRef.current.value,
      phone: phoneInputRef.current.value,
      username: usernameInputRef.current.value,
      password: passwordInputRef.current.value,
      confirm_password: repeatPasswordInputRef.current.value,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/v1/user/infoUpdate`,
        requestData
      )
      .then((response) => {
        const result = response.data;
        if (result.success) {
          navigate("/login", {
            state: { phone: phoneInputRef.current.value },
          });
          toast.success("ثبت نام اولیه با موفقیت انجام شد");
        } else {
          toast.error(result.error.description);
          document.getElementById("hint_text").innerText =
            "ثبت نام با خطا مواجه شد.";
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          toast.error(error.response.data.error.description);
        } else {
          toast.error("خطایی رخ داد. لطفا مجددا تلاش کنید.");
        }
      });
  }

  return (
    <div className={classes.main}>
      <div className={classes.container}>
        <div className={classes.section_logo}>
          <img className={classes.logo_img} alt="Logo" src={logo}></img>
        </div>
        <div className={classes.section_form}>
          <form className={classes.form}>
            <p id="hint_text" className={classes.hint}></p>
            <div className={classes.form_Div}>
              <input
                type="text"
                placeholder="نام"
                className={classes.input}
                required
                ref={nameInputRef}
              />
              <input
                type="text"
                placeholder="نام خانوادگی"
                className={classes.input}
                required
                ref={familyInputRef}
              />
              <input
                type="tel"
                placeholder="شماره تلفن"
                className={classes.input}
                required
                ref={phoneInputRef}
              />
              <input
                type="text"
                placeholder="نام کاربری"
                className={classes.input}
                required
                ref={usernameInputRef}
              />
              <input
                type="password"
                placeholder="رمز عبور"
                className={classes.input}
                required
                ref={passwordInputRef}
              />
              <input
                type="password"
                placeholder="تکرار رمز عبور"
                className={classes.input}
                required
                ref={repeatPasswordInputRef}
              />
            </div>
          </form>
          <div className={classes.already_have_account}>
            <p>
              اکانت دارید؟<u onClick={() => navigate("/login")}> وارد شوید</u>
            </p>
          </div>
          <button className={classes.submitButton} onClick={postRegisterData}>
            تایید
          </button>
          <button className={classes.recieve_SMS} onClick={() => navigate(-1)}>
            بازگشت{" "}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Register1;
